import styled from 'styled-components';

export const Wrap = styled.div`
  width: 100%;
`;

export const WrapHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 53px;
  width: 100%;

  h2 {
    margin-left: 15px;
    font-size: 14px;
    color: #151515;
  }

  select {
    margin-right: 15px;
    padding-right: 20px;
    border: none;
    background-color: transparent;
    background: url('/images/select-arrow.svg') no-repeat 95% 50%;
    background-size: 9px;
  }
`;

export const Tab = styled.div`
  box-sizing: border-box;
  display: flex;
  // height: 74px;
  width: 100%;
  padding: 0px 15px 20px 15px;
  background-color: #ffffff;
`;

export const Button = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  border: solid 1px #78818e;
  background-color: #ffffff;
  font-size: 13px;
  &.active {
    background-color: #78818e;
    color: #ffffff;
  }
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #f2f2f2;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  width: 100%;
  background-color: $community-grey;
  border-bottom: 1px solid #f2f2f2;

  & > div {
    display: flex;
    justify-content: center;
    font-size: 11px;
  }

  .rank {
    width: 32px;
    margin-left: 10px;
  }

  .team {
    justify-content: flex-start !important;
    align-items: center;
    width: 116px;
  }

  .game,
  .win,
  .draw,
  .loss,
  .winPer {
    flex: 1;
  }
`;

export const Ul = styled.ul`
  display: flex;
  flex-direction: column;

  li {
    display: flex;
    align-items: center;
    height: 44px;
    width: 100%;
    border-bottom: 1px solid #f2f2f2;

    &:last-child {
      border-bottom: none;
    }

    & > div {
      display: flex;
      justify-content: center;
    }

    .rank {
      width: 32px;
      font-size: 13px;
      font-weight: 300;
      margin-left: 10px;
    }

    .team {
      justify-content: flex-start !important;
      align-items: center;
      width: 116px;

      img {
        margin-right: 10px;
      }
    }

    .game,
    .win,
    .draw,
    .loss,
    .winPer {
      flex: 1;
      font-size: 13px;
      font-weight: 300;
    }
  }

  .active {
    background-color: #fff7f7;
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    border-bottom: none;
  }
`;
